import { Registerable } from '@grouper/modules/core/registry'
import FieldPermissionsContextItem from '@grouper_enterprise/components/fieldPermissions/FieldPermissionsContextItem'

export class FieldPermissionsContextItemType extends Registerable {
  static getType() {
    return 'field-permissions'
  }

  getComponent() {
    return FieldPermissionsContextItem
  }
}
